import React from 'react';
import { Link as v4Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Modal from '@zg-rentals/multibrand-ui/lib/Modal';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import EmailVerificationActions from 'app/shared/actions/EmailVerificationActions';
import ModalActions from 'app/shared/actions/ModalActions';
import ModalConstants from 'app/shared/constants/ModalConstants';

// style
import './style.scss';

class VerifyEmailModal extends React.Component {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        emailAddress: PropTypes.string.isRequired,
        handleResendEmailClick: PropTypes.func.isRequired,
        activeListings: PropTypes.array.isRequired,
        inactiveListings: PropTypes.array.isRequired,
        isPostingPathAdmin: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);

        // init state
        this.state = {
            isOpen: this.props.isOpen,
            resendEmailText: '',
        };

        // bind
        this.handleResendEmailClick = this.handleResendEmailClick.bind(this);
        this.modalClose = this.modalClose.bind(this);
        this.modalOpen = this.modalOpen.bind(this);
        this.renderAddress = this.renderAddress.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.isOpen !== this.state.isOpen)) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    }

    modalClose() {
        this.props.dispatch(ModalActions.updateDisplayVerifyEmailModal({ isOpen: false }));
    }

    modalOpen() {
        this.props.dispatch(ModalActions.updateDisplayVerifyEmailModal({ isOpen: true }));
    }

    handleResendEmailClick() {
        const { emailAddress } = this.props;
        const notificationText = `Email resent! The feed listings associated with your account will be added once you
              verify your email at ${emailAddress}.`;

        if (this.props.isPostingPathAdmin) {
            this.modalClose();
            this.props.handleResendEmailClick(notificationText);
        } else {
            this.props.dispatch(EmailVerificationActions
                .sendSecurityToken({ emailVerificationType: 'claimFeedListings' }))
                .then((response) => {
                    if (response.success) {
                        this.modalClose();
                        this.props.handleResendEmailClick(notificationText);
                    }
                })
                .catch((err) => {
                    global.TEMPORARY_global_logger.error(err, 'Failed to send email verification security token');
                });
        }
    }

    renderAddress(listing, i) {
        const {
            street,
            unit,
            city,
            state,
            zip,
        } = listing;

        let streetDisplay = street;

        if (listing.unit) {
            streetDisplay += ` ${unit}`;
        }
        return (
            <Text
                className="VerifyEmailModal-listing-item"
                type="body-small"
                key={i}
            >
                {streetDisplay}
,
                {city}
,
                {state}
                {' '}
                {zip}
            </Text>
        );
    }

    render() {
        const { isOpen, resendEmailText } = this.state;
        const {
            activeListings,
            inactiveListings,
            emailAddress,
        } = this.props;
        const parentSelector = ModalConstants.MODAL_PARENT_SELECTOR;

        return (
            <Modal
                className="VerifyEmailModal"
                isOpen={isOpen}
                parentSelector={this.parentSelector}
                shouldBypassBodyStyling={true}
                onRequestClose={this.modalClose}
                header="Listings Found"
                isWizard={true}
                id={parentSelector}
            >
                <div className="VerifyEmailModal-content">
                    <SpacerRow>
                        <Text
                            type="h3"
                        >
                            We found listings associated with your email address from other sources.
                        </Text>
                    </SpacerRow>

                    <SpacerRow>
                        <Text
                            type="body"
                        >
                            We&apos;ve sent an email to
                            {' '}
                            <b>{emailAddress}</b>
.
                            Click the link in the email to confirm your email address and
                            access those listings in Zillow Rental Manager.&nbsp;
                            <Link
                                reactRouterLink={v4Link}
                                onClick={() => this.handleResendEmailClick()}
                            >
                                Resend email
                            </Link>
                        </Text>
                    </SpacerRow>

                    {
                        resendEmailText && (
                            <SpacerRow>
                                <Text
                                    type="body"
                                    emphasize={true}
                                >
                                    { resendEmailText }
                                </Text>
                            </SpacerRow>
                        )}

                    {
                        activeListings.length > 0 && (
                            <SpacerRow>
                                <Text
                                    type="h5"
                                    uppercase={true}
                                >
                                Active Listings
                                </Text>

                                {
                                    activeListings.map((listing, i) => this.renderAddress(listing, i))
                                }
                            </SpacerRow>
                        )}

                    {
                        inactiveListings.length > 0 && (
                            <SpacerRow>
                                <Text
                                    type="h5"
                                    uppercase={true}
                                >
                                Inactive Listings
                                </Text>

                                {
                                    inactiveListings.map((listing, i) => this.renderAddress(listing, i))
                                }
                            </SpacerRow>
                        )}
                </div>
            </Modal>
        );
    }
}

export { VerifyEmailModal };
export default connect()(VerifyEmailModal);
